(function (app) {

    app.provider("marketingTrackerArcEventApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getArcEvents = function () {
                            return marketingTrackerApiGateway.getArray("/Events/Arc");
                        }

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line